import { SVGProps } from 'react';

export const ProviderFolderIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 151 201" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="33" height="35" rx="12" transform="matrix(-1 0 0 1 66 31)" fill="currentColor" />
      <rect width="33" height="35" rx="12" transform="matrix(-1 0 0 1 119 31)" fill="currentColor" />
      <rect width="33" height="35" rx="12" transform="matrix(-1 0 0 1 66 83)" fill="currentColor" />
      <rect width="33" height="35" rx="12" transform="matrix(-1 0 0 1 119 83)" fill="currentColor" />
      <rect width="33" height="35" rx="12" transform="matrix(-1 0 0 1 66 135)" fill="currentColor" />
      <path
        d="M119 147C119 140.373 113.627 135 107 135H98C91.3726 135 86 140.373 86 147V198H119V147Z"
        fill="currentColor"
      />
      <path
        d="M26 7C15.5066 7 7 15.5066 7 26V175C7 185.493 15.5066 194 26 194H125C135.493 194 144 185.493 144 175V26C144 15.5066 135.493 7 125 7H26Z"
        stroke="currentColor"
        strokeWidth="14"
      />
    </svg>
  );
};
